module.exports = __webpack_public_path__ + "media/images/flechebas-simple-28928d23bb683fcd207150bb02ed5922.svg";